export const UtilGestureModifier = wcardinal.ui.UtilGestureModifier;